export default {
  //授课计划
  planList: '',
  planInfo: {
    add: '',
    detailTeam:''
  },
  courseList:'',
  deleteById:'',
  addXzClass:'',
  viewCourseTree:''
}



// WEBPACK FOOTER //
// ./src/store/skPlan/states.js